export enum ResourceScopeType {
  Dedicated = 'DEDICATED',
  Branch = 'BRANCH',
  BranchGroup = 'BRANCH_GROUP'
}
